if (!customElements.get('product-bundles')) {
  class ProductBundles extends HTMLElement {
    constructor() {
      super();

      this.inputs = Array.from(this.querySelectorAll('[data-bundles-input]'));
      this.rows = Array.from(this.querySelectorAll('[data-bundles-row]'));
      this.toggle = this.querySelector('[data-bundles-toggle]');
      this.collapse = this.querySelector('.accordion-collapse');
      this.closeButton = this.querySelector('[data-bundles-close]');
      this.clearButton = this.querySelector('[data-bundles-clear]');
      this.applyButton = this.querySelector('[data-bundles-apply]');
      this.errorElement = this.querySelector('[data-bundles-error]');
      this.spinner = this.querySelector('.loading__spinner');

      this.rows.forEach((row) => row.addEventListener('click', this.onRowClick.bind(this)));
      this.inputs.forEach((input) => input.addEventListener('change', this.onSelectionChange.bind(this)));

      if (this.closeButton) this.closeButton.addEventListener('click', this.onClose.bind(this));
      if (this.clearButton) this.clearButton.addEventListener('click', this.onClear.bind(this));
      if (this.applyButton) this.applyButton.addEventListener('click', this.onApply.bind(this));

      this.onSelectionChange();
    }

    get selectedInputs() {
      return this.inputs.filter((input) => input.checked && !input.disabled);
    }

    onRowClick(event) {
      if (event.target.closest('a')) return;

      const input = event.currentTarget.querySelector('[data-bundles-input]');
      if (!input || input.disabled) return;

      if (event.target !== input) input.checked = !input.checked;
      this.onSelectionChange();
    }

    onSelectionChange() {
      this.inputs.forEach((input) => {
        const row = input.closest('[data-bundles-row]');
        if (row) row.classList.toggle('is-selected', input.checked);
      });

      if (this.applyButton) this.applyButton.disabled = this.selectedInputs.length === 0;
      this.hideError();
    }

    onClear() {
      this.inputs.forEach((input) => (input.checked = false));
      this.onSelectionChange();
    }

    onClose() {
      if (this.toggle && this.collapse && this.collapse.classList.contains('show')) this.toggle.click();
    }

    onApply() {
      const items = this.selectedInputs.map((input) => ({ id: Number(input.value), quantity: 1 }));
      if (items.length === 0) return;

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = { items: items };

      if (cart) {
        body.sections = cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }

      this.setLoading(true);

      fetch(`${routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.showError(response.description || response.message);
            return;
          }

          if (!cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-bundles', cartData: response });
          }

          cart.renderContents(response);
          this.onClear();
          this.onClose();
        })
        .catch(() => {
          this.showError(window.cartStrings ? window.cartStrings.error : '');
        })
        .finally(() => {
          if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          this.setLoading(false);
        });
    }

    setLoading(isLoading) {
      if (this.applyButton) {
        this.applyButton.classList.toggle('loading', isLoading);
        this.applyButton.disabled = isLoading || this.selectedInputs.length === 0;
      }
      if (this.spinner) this.spinner.classList.toggle('hidden', !isLoading);
    }

    showError(message) {
      if (!this.errorElement || !message) return;
      this.errorElement.textContent = message;
      this.errorElement.hidden = false;
    }

    hideError() {
      if (!this.errorElement) return;
      this.errorElement.textContent = '';
      this.errorElement.hidden = true;
    }
  }

  customElements.define('product-bundles', ProductBundles);
}
